module.exports = __webpack_public_path__ + "71e6ddf079c492aa4495ab5a252b3764.pdf";